import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import "dayjs/locale/cs";

dayjs.extend(isoWeek);
dayjs.locale("cs");
